import { SelectData } from "mui-rff";
import countries from "./countries.json";

export const countrySelectData: SelectData[] = countries.map((x) => ({
  label: x.name,
  value: x.code,
}));
